module.exports = {"id":"36111","name":"Kyle Beckerman","rating":"72","photo":"./data/images/photos/2/36111.png","club":{"name":"Real Salt Lake","logo":"./data/images/clubs/RealSaltLake.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KyleBeckerman0.json
// module id = 2413
// module chunks = 0